import { PhotoActionType } from '../action/PhotoAction';

const defaultState = {
  loading: false,
  success: false,
  url: null,
};

export default function PhotoReducer(state = defaultState, action) {
  switch (action.type) {
    case PhotoActionType.UPLOADING:
      return Object.assign({}, defaultState, {
        loading: true,
      });
    case PhotoActionType.UPLOAD_SUCCESS:
      return Object.assign({}, defaultState, {
        url: action.url,
      });
    case PhotoActionType.ERROR:
      return Object.assign({}, defaultState, {
        error: action.error,
      });
    case PhotoActionType.RESET:
      return defaultState;
    default:
      break;
  }

  return state;
}
